import { getOwnerName } from '../../../common/store/members/members-selectors';
import { CommentStatus } from '../../../controller/services/comments-service-types';
export const resolveReplyingToText = ({ targetComment, replyingToOwner, replyingToId, t, }) => {
    if (replyingToId === (targetComment === null || targetComment === void 0 ? void 0 : targetComment.commentId) &&
        targetComment.status === CommentStatus.DELETED &&
        !targetComment.replyTo) {
        return t('comment.replying-to.deleted-comment');
    }
    return getOwnerName(replyingToOwner, t);
};
//# sourceMappingURL=reply-state-switch-utils.js.map